import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useEffect, useMemo, useRef } from 'react';

import { useOverscrollLock } from '../../../hooks/use-overscroll-lock';
import { getTargetUrl } from '../../../utils/bread-crumbs';
import { RouteLink } from '../../route-link/route-link';
import { BreadCrumbKeyType, BreadCrumbType } from '../bread-crumbs-prop-types';

import './bread-crumbs-menu.scss';

function useScrollToActive(isOpen, items, activeKey) {
  const scrollAreaRef = useRef();
  const elementPosition = useMemo(() => items && items.findIndex(({ key }) => activeKey === key), [items, activeKey]);

  useEffect(() => {
    if (isOpen && scrollAreaRef.current.childNodes[elementPosition]) {
      scrollAreaRef.current.childNodes[elementPosition].scrollIntoView(false);
    }
  }, [isOpen, elementPosition]);

  return scrollAreaRef;
}

function BreadCrumbsMenuUI({ activeKey, items, type, isLive, isOpen, onClick }) {
  const scrollAreaRef = useScrollToActive(isOpen, items, activeKey);
  useOverscrollLock(scrollAreaRef);
  return (
    <div ref={scrollAreaRef} className="sb-BreadCrumbsMenu">
      {items.map(({ key, label, data, isLive: isLiveGame }) => (
        <div key={key} className={clsx('sb-BreadCrumbsMenu-item', activeKey === key && 'isActive')}>
          <div className="sb-BreadCrumbsMenu-item-linkWrapper">
            <RouteLink
              activeClassName="isActive"
              className="sb-BreadCrumbsMenu-item-link"
              to={getTargetUrl(type, data, isLive)}
              onClick={onClick}>
              <span>{label}</span>
              {isLiveGame && <span className="sb-BreadCrumbsMenu-item-isLive" />}
            </RouteLink>
          </div>
        </div>
      ))}
    </div>
  );
}

BreadCrumbsMenuUI.propTypes = {
  type: PropTypes.string.isRequired,
  activeKey: BreadCrumbKeyType.isRequired,
  isLive: PropTypes.bool,
  items: PropTypes.arrayOf(BreadCrumbType).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

BreadCrumbsMenuUI.defaultProps = {
  isLive: false,
};

export const BreadCrumbsMenu = memo(BreadCrumbsMenuUI);
